const ErrorText = ({ text }) => {
  return (
    <div className="text-red-600 text-[12px] italic font-light py-1">
      {text}
    </div>
  );
};

export default ErrorText;
